/**
 * A request the server refused as unauthenticated.
 *
 * The stream endpoints attach the HTTP status to the error they throw, and
 * their fetch has already refreshed the session once (`fetchWithSessionRefresh`),
 * so a 401 that reaches the store is one a refresh did not cure: the refresh
 * failed, or a fresh cookie still is not arriving — dropped when the cookie jar
 * outgrows the browser's per-domain limit. No turn was created.
 */
export const isSessionExpiredError = (error: unknown): boolean =>
  (error as { status?: number } | null)?.status === 401;
